
export default {
  name: 'Model3dWithPreview',
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: 0,
      modelLoad: 0,
      isMounted: false,
      showVideoModal: false,
      animationsEnd: false,
      timer: null,
    }
  },
  computed: {
    isPreviewLinkExist() {
      return this.model?.preview?.src && this.model?.preview?.src?.length > 0
    },
    isModelLinkExist() {
      return this.model?.file?.src && this.model?.file?.src?.length > 0
    },
    loadComponent() {
      return () => import('@google/model-viewer')
    },
    isPosterActive() {
      return this.activeTab === 0
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      this.isMounted = true
      this.loadComponent()
      this.timer = setTimeout(() => {
        this.animationsEnd = true
      }, 1000)
    }
  },
  methods: {
    updateLoading(e) {
      if (e?.detail?.totalProgress === 1) {
        setTimeout(() => {
          this.modelLoad = 100
        }, 100)
      } else {
        this.modelLoad = e?.detail?.totalProgress * 100 || 0
      }
    },
  },
}
